// src/components/HorseTypeBadge.jsx
// Colour-coded badge for horse type column.
// Replaces the plain grey <Chip> throughout your app.
//
// Usage:
//   import HorseTypeBadge from '../components/HorseTypeBadge';
//   <HorseTypeBadge type={horse.type} />
//
// horse.type values seen in your API: "Mare", "Stallion", "Colt", "Filly", "Gelding"

import React from 'react';
import { Chip } from '@mui/material';
import { TYPE_COLORS } from '../theme';

const DEFAULT = { bg: '#F5F5F5', color: '#616161', border: '#E0E0E0' };

export default function HorseTypeBadge({ type }) {
  const s = TYPE_COLORS[type] ?? DEFAULT;
  return (
    <Chip
      label={type ?? '—'}
      size="small"
      sx={{
        backgroundColor: s.bg,
        color: s.color,
        border: `1px solid ${s.border}`,
        fontWeight: 600,
        fontSize: '0.7rem',
        height: 22,
        borderRadius: '4px',
        '& .MuiChip-label': { px: 1 },
      }}
    />
  );
}
